import { getGridStringOperators } from '@mui/x-data-grid-pro';

/** Normal string kolonları için: İçermez ve Eşit Değildir hariç operatörler. */
export const filterOperatorsString = getGridStringOperators().filter(
    (op) => op.value !== 'doesNotContain' && op.value !== 'doesNotEqual'
);
